import { render, staticRenderFns } from "./registrationList.vue?vue&type=template&id=2d7bde79&scoped=true"
import script from "./registrationList.vue?vue&type=script&lang=js"
export * from "./registrationList.vue?vue&type=script&lang=js"
import style0 from "./registrationList.vue?vue&type=style&index=0&id=2d7bde79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7bde79",
  null
  
)

export default component.exports